<template>
  <div class="wrap" v-bind:style="{ display: visible ? 'flex' : '' }">
    <p class="name"  v-bind:style="'color:' + (is_artist ? '#ffcc66' : '#fff')">
      {{name}}
    </p>

    <div class="chat-wrapper">
      <div class="messages" ref="messages_element">
        <div v-for="(message, index) in messages" v-bind:key="index" style="display: flex; overflow: hidden">
          <div style="display: flex; margin-right: 8px">
            <span v-bind:style="`font-weight: ${message.b ? 700 : 200}; ` + 'color:' + (message.nameColor ? message.nameColor : '#fff') + '; margin-top: 6px; font-size: 18px'">{{message.name}}</span>
          </div>
          <p v-bind:style="`font-weight: ${message.b ? 700 : 200};` +'margin-top: 6px; text-align: left; font-size: 18px; color: ' + (message.chatColor ? message.chatColor : '#999')">{{message.msg}}</p>
        </div>
        <p style="padding: 4px"> </p>
      </div>
    </div>

    <div class="input">
      <input type="text" v-model="message" v-on:keydown="send" placeholder="Message..." maxLength="100" ref="input" />
      <button v-on:click="send" style="padding: 16; background-color: '#fff'">SEND</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Chat',
  data: function() {
    return {
      message: '',
      updated: false
    }
  },
  props: {
    visible: Boolean,
    name: String,
    messages: Array,
    is_artist: Boolean
  },
  watch: { 
    messages: function(newVal, oldVal) { 
      // watch messages, to jump to bottom of chatbar
      this.updated = true;
    }
  },
  updated() {
    if(!this.updated) return;

    /** wont update until message update again **/
    this.updated = false;

    let dif = Math.abs(this.$refs.messages_element.scrollTop - this.$refs.messages_element.scrollHeight);

    if(dif < 500)
      this.$refs.messages_element.scrollTop = this.$refs.messages_element.scrollHeight;
  },
  methods: {
    close() {

    },
    send(e) {
      if(e.type === 'keydown' && e.keyCode !== 13)
        return;

      this.$emit('send', this.message);
      this.message = '';
    }
  },
  mounted() {
    document.addEventListener('keyup', e => {
      // if user presses T
      if(e.keyCode !== 84) return;

      this.$refs.input.focus();
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Rowdies:wght@300;400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@200;300,400;700&display=swap');

  .wrap {
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: 280px;
    height: 400px;
    background-color: rgba(0,0,0,.25);
    box-shadow: 0 0 20px -5px #000;
    display: flex;
    flex-direction: column;
  }

  .name {
    margin: 10px;
    font-size: 24px;
    font-family: 'Rowdies', cursive;
    color: #fff;
  }

  .chat-wrapper {
    /*padding: 10px;*/
    box-sizing: border-box;
    flex: 1;
    position: relative;
    display: flex;
    overflow-y: scroll;
    width: 100%;
    padding: 0 10px;
    flex-direction: column;

  }

  .chat-wrapper .messages {
    width: 100%;
    position: relative;
    overflow-y: scroll;
    font-family: 'Raleway', sans-serif !important;
    /*flex: 0 1 auto;*/
    /*background-color: #999;*/
  }

  .input {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    font-size: 18px;
    font-family: 'Raleway', sans-serif !important;
    outline: none !important;
  }

  .input input {
    flex: 1;
    color: #fff;
    box-shadow: 0 0 20px -5px #000;
    font-size: 18px;
    outline: none;
    width: 80%;
    padding: 10px 10px;
    background-color: #000;
  }

  .input button {
    font-size: 18px;
    padding: 10px 20px;
    font-family: 'Rowdies', cursive;
    /*font-family: 'Raleway', sans-serif !important;*/
    background-color: #fff!important;
  }

  /* .sidebar .input {
      color: #999;
      box-shadow: 0 0 20px -5px #000;
      background-color: #111;
      width: 100%;
      box-sizing: border-box;
      border-radius: 30px;
      font-size: 14px;
      outline: none !important;
      margin-top: 14px;
      display: flex;
      overflow: hidden;
  }

  .sidebar input {
    flex: 1;
    color: #999;
      box-shadow: 0 0 20px -5px #000;
      background-color: #111;
      padding: 18px 28px;
      width: 80%;
      font-size: 14px;
      outline: none;
  }*/

  @media screen and (max-width: 800px) {
    .wrap {
      display: none;
      position: fixed;
      top: 0px;
      left: 0px;
      bottom: 0px;
      left: 0px;
      width: 100vw;
      height: 100%;
      z-index: 3000;
      height: -webkit-fill-ava ilable;
      background-color: rgba(0,0,0,.5);
    }

    .input input, .input button {
      font-size: 22px;
    }
  }
</style>
